import { Component, OnInit } from '@angular/core';
import { TooltipPosition } from '@angular/material/tooltip';
import { FormControl } from '@angular/forms';
import { UserService } from 'src/app/services/user/user.service';
import { Router } from '@angular/router';
import { Departments } from 'src/app/services/user/user-enum';
import { DocumentEnum } from 'src/app/services/documentsOperation/DocumentEnum';
import { DocumentsService } from 'src/app/services/documentsOperation/documents-service.service';
import { ToastrService } from 'ngx-toastr';
import { ExportDocumentsZipComponent } from './export-documents-zip/export-documents-zip.component';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { GenericConfirmationDialogComponent } from 'src/app/core/generic-confirmation-dialog/generic-confirmation-dialog.component';

@Component({
  selector: 'app-export-documents',
  templateUrl: './export-documents.component.html',
  styleUrls: ['./export-documents.component.scss']
})
export class ExportDocumentsComponent implements OnInit{

  positionOptions: TooltipPosition[] = ['above'];
  isSpinnerActive;
  depSearch;
  departments: string[] = [];
  idTitleSearch;
  ids: string[] = [];
  page: number = 1;
  pageSize: number = 20;
  searchQuery;
  totalPages: number = 0;
  filteredDocumentData
  position = new FormControl(this.positionOptions[0]);
  documentData;
  selectedCapability;
  selectedDocuments;
  private dialogRef?: MatDialogRef<GenericConfirmationDialogComponent>;

  selectedUsersDoc;
  filteredUsersDoc;
  isChecked;
  constructor(
    public userService: UserService,
    private router: Router,
    private documentService: DocumentsService,
    private toaster: ToastrService,
    private dialog: MatDialog
  ) { }

  ngOnInit(): void {
    this.selectedUsersDoc = [];   
    this.getDocumentsinfo();
    for (const department of Object.values(Departments)) {
      if (isNaN(Number(department))) {
        this.departments.push(department);
      }
    }
    for (const doc of Object.values(DocumentEnum)) {
      if (isNaN(Number(doc))) {
        if (doc == DocumentEnum.AADHAAR || doc == DocumentEnum.ADDRESS_PROOF || doc == DocumentEnum.PAN || doc == DocumentEnum.VOTER_ID) {
          if (doc == DocumentEnum.AADHAAR || doc == DocumentEnum.PAN) {
            this.ids.push(doc);
          }
          else {
            this.ids.push(doc);
          }

        }
        this.ids.sort()
      }
    }
  }

  ngOnDestroy(): void {
    if (this.dialogRef) {
      this.dialogRef.close();
    }
  }


  getFormattedType(value: string): string {
    const words = value.toLowerCase().split('_');
    return words
      .map((word) => {
        if (word === 'pan') return 'PAN';
        if (word === 'id') return 'ID';
        if (word === 'license') return 'License';
        return word.charAt(0).toUpperCase() + word.slice(1);
      })
      .join(' ');
  }
  sendMailToSelectedUsers() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      header: 'Mail All Employees',
      text: 'Are you sure you want to send reminder email to all the selected employees?'
    };
    dialogConfig.panelClass = 'activate-employee';

    this.dialogRef = this.dialog.open(GenericConfirmationDialogComponent, dialogConfig);

    this.dialogRef.afterClosed().subscribe((res) => {
      if (res === 'Yes') {
        this.documentService.triggerMailToSelectedUsers(this.selectedUsersDoc).subscribe(
          {
            next: (response) => {
              this.toaster.success(response.body.message);
              this.selectedUsersDoc=[];
              this.isChecked=false;
              this.getDocumentsinfo();
            },
            error: (error) => {
              this.toaster.error('Failed to send reminder mail.');
              console.error(error);
            }
          }
        )
      }
    });
    
  }

  isSelected(user): boolean {
  return this.selectedUsersDoc?.includes(user);
}
  toggleSelectAll(): void {
    if (this.isChecked) {
      this.selectedUsersDoc = [];
      this.isChecked = false;
    } else {
      this.selectedUsersDoc = [...this.filteredDocumentData]; 
      this.isChecked = true;
    }
  }

  toggleSelectUserDoc(user): void {
    const index = this.selectedUsersDoc.indexOf(user);
    if (index === -1) {
      this.selectedUsersDoc.push(user);
    } else {
      this.selectedUsersDoc.splice(index, 1);
    }

    // Update select all checkbox status
    if (this.selectedUsersDoc.length === this.filteredDocumentData.length) {
      this.isChecked = true;
    } else {
      this.isChecked = false;
    }
  }

  getDocumentsinfo(){
    this.isSpinnerActive=true;
    this.isSpinnerActive = true;
    this.documentData = [];
    this.filteredDocumentData = [];
    this.userService.getAllUserDetailsDetail(
      this.page - 1,
      this.pageSize,
      this.searchQuery,
      this.selectedCapability,
      this.selectedDocuments
    ).subscribe(res => {
      this.documentData = res.body?.employeeExportDTOS?.content;
      this.filteredDocumentData = [...this.documentData];
      this.filteredDocumentData.forEach(element => {
        if (element.userThumbnailImage !== '') {
          element.userThumbnailImage =
            'data:image/png;base64,' + element.userThumbnailImage;
        }
      });
      this.totalPages = res.body?.employeeExportDTOS?.totalPages || 0;
      this.isSpinnerActive = false;
    })
  }
  navigateToProfile(id) {
    this.router.navigate(['/employee/employee-profile', id, 'spotlight']);
  }
  onPageChange(event) {
    this.page = event;
    this.getDocumentsinfo();
  }
  openExportOptions() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.width = "30%";
    dialogConfig.height = "33%";
    dialogConfig.panelClass = "activate-employee"
    const dialogRef = this.dialog.open(ExportDocumentsZipComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(() => { });
  }
  onFilterChangeCap() {
    this.page = 1;
    this.selectedCapability = this.depSearch.map(capability => this.getDepartmentKeyByValue(capability));
    this.getDocumentsinfo();
  }

  onFilterChangeDoc() {
    this.page = 1;
    this.selectedDocuments = this.idTitleSearch.map(doc => this.getDocumentKeyByValue(doc));
    this.getDocumentsinfo();
  }
  getDepartmentKeyByValue(value: string): string | undefined {
    return Object.keys(Departments).find(key => Departments[key] === value);
  }
  getDocumentKeyByValue(doc: string) {
    return Object.keys(DocumentEnum).find(key => DocumentEnum[key] === doc);
  }
  emailAllUsers() {
    this.documentService.triggerMailToAllUsers().subscribe(
      {
        next: (response) => {
          this.toaster.success(response.body.message);
        },
        error: (error) => {
          this.toaster.error('Failed to send reminder mail.');
          console.error(error);
        }
      }
    )
  }
  emailSingleUser(id) {
    this.documentService.triggerMailToSingleUser(id).subscribe(
      {
        next: (response) => {
          this.toaster.success(response.body.message);
        },
        error: (error) => {
          this.toaster.error('Failed to send reminder mail.');
          console.error(error);
        }
      }
    )
  }
  confirmEmailSingleUser(id: string, username: string) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      header: 'Mail Employee',
      text: `Are you sure you want to send reminder email to ${username}?`
    };
    dialogConfig.panelClass = 'activate-employee';

    this.dialogRef = this.dialog.open(GenericConfirmationDialogComponent, dialogConfig);

    this.dialogRef.afterClosed().subscribe((res) => {
      if (res === 'Yes') {
        this.emailSingleUser(id);
      }
    });
  }

  confirmEmailAllUsers() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      header: 'Mail All Employees',
      text: 'Are you sure you want to send reminder email to all the employees?'
    };
    dialogConfig.panelClass = 'activate-employee';

    this.dialogRef = this.dialog.open(GenericConfirmationDialogComponent, dialogConfig);

    this.dialogRef.afterClosed().subscribe((res) => {
      if (res === 'Yes') {
        this.emailAllUsers();
      }
    });
  }

  allDocsUploaded(id) {
    this.documentService.triggerMailToSingleUser(id).subscribe(
      {
        next: (response) => {
          this.toaster.success('All documents are uploaded. No reminder sent.');
        },
        error: (error) => {
          this.toaster.error('Failed to send reminder mail.');
          console.error(error);
        }
      }
    )
  }

  formatCapability(value: string): string {
    if (!value) return '';
    let result = value.replace(/_/g, ' ');
    result = result.replace(/\b\w+/g, word => {
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
    });
    result = result.replace(/\bApi\b/, 'API');
    return result;

  }

  ifOverflow(e) {
    return e.scrollWidth > e.clientWidth;
  }
  onSearchInput(value: string): void {
    this.searchQuery = value.trim();
    this.page = 1;
    this.getDocumentsinfo();
  }
}